export default "__VITE_ASSET__CnKEFTt$__"